import apiClient from 'ps-components/lib/apiClient';

export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_SELECT_SURVEY = 'SURVEY_MIGRATION_REVIEW_DATA_CUTS_SELECT_SURVEY';
export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_CLOSE_ERROR = 'SURVEY_MIGRATION_REVIEW_DATA_CUTS_CLOSE_ERROR';
export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_DATA_CUT_SEARCH =
  'SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_DATA_CUT_SEARCH';
export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_UPDATE_DATA_CUTS = 'SURVEY_MIGRATION_REVIEW_DATA_CUTS_UPDATE_DATA_CUTS';

export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_SURVEYS_SEARCH =
  'SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_SURVEYS_SEARCH';

export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_INIT = 'SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_INIT';
export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_SUCCESS =
  'SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_SUCCESS';
export const SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_FAIL = 'SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_FAIL';

export const searchSurveys = e => async dispatch => {
  const searchValue = e.target.value;
  dispatch({
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_SURVEYS_SEARCH,
    payload: searchValue
  });

  //  TODO: Implement MPE-4386	Survey Migration: Data Cut Priority - UI - Integration with API's
  dispatch({ type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_INIT });
  try {
    const result = await apiClient.apiGet('api/surveys/migration/getSurveys', {
      params: {
        sort: [{ property: 'survey_code', direction: 'ASC' }],
        headerfilters: [{ property: 'pub_survey_short_name', value: searchValue }],
        page: 1,
        start: 0,
        limit: 100
      }
    });
    if (result.data.success) {
      console.log('results', result.data.data.surveys);
      dispatch({ type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_SUCCESS, payload: result.data.data });
    } else {
      dispatch({ type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_FAIL });
    }
  } catch (err) {
    dispatch({ type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_FAIL, payload: err });
  }
};

export const clearSearchSurveys = () => {
  return {
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_SURVEYS_SEARCH,
    payload: ''
  };
  //  TODO: Implement MPE-4386	Survey Migration: Data Cut Priority - UI - Integration with API's
};

export const searchDataCuts = value => {
  //  TODO: Implement MPE-4386	Survey Migration: Data Cut Priority - UI - Integration with API's
  return {
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_DATA_CUT_SEARCH,
    payload: value
  };
};

export const clearSearchDataCuts = () => {
  return {
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_DATA_CUT_SEARCH,
    payload: ''
  };
  //  TODO: Implement MPE-4386	Survey Migration: Data Cut Priority - UI - Integration with API's
};

export const selectSurvey = surveyCode => {
  return {
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_SELECT_SURVEY,
    payload: surveyCode
  };
};

const _updateDataCuts = (item, param, value, dispatch, getState) => {
  const id = item.unique_identifier;

  const oldDataCuts = getState().surveyMigration.reviewDataCuts.selectedSurveyDataCuts;
  const newDataCuts = oldDataCuts.map(c => {
    if (c.unique_identifier === id) {
      const newCut = { ...c };
      newCut[param] = value;
      return newCut;
    } else return c;
  });

  dispatch({
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_UPDATE_DATA_CUTS,
    payload: newDataCuts
  });
  //  TODO: Implement MPE-4386	Survey Migration: Data Cut Update - UI - Integration with API's
};

export const updateDataCutSelection = item => async (dispatch, getState) => {
  _updateDataCuts(item, 'job_scope_checked', !item.job_scope_checked, dispatch, getState);
};

export const updateDataCutPriority = (item, value) => async (dispatch, getState) => {
  _updateDataCuts(item, 'priority_level', value, dispatch, getState);
};

export const updateCurrencyFilter = value => async (dispatch, getState) => {
  //  TODO: Implement me
};

export const closeError = () => {
  return {
    type: SURVEY_MIGRATION_REVIEW_DATA_CUTS_CLOSE_ERROR
  };
};
